// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { formatNumber, formatPercentage } from "@sequentech/ui-core";
/** Writes a pie or donut chart's slice percentages and hovered counts in `numberFormatPolicy`. */
export var getPieChartNumberFormatOptions = function (numberFormatPolicy) { return ({
    dataLabels: {
        formatter: function (percentage) { return formatPercentage(Number(percentage), numberFormatPolicy, 1); },
    },
    tooltip: {
        y: {
            formatter: function (count) { return formatNumber(count, numberFormatPolicy); },
        },
    },
}); };
